import { NumberFormatter } from 'components/shared/NumberFormatter/NumberFormatter';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import type { PercentProps } from './model';
import { defaultIncrementStep } from './model';

interface CustomProperties {
  disabledColor?: string;
}

const StyledNumberFormatter = styled(NumberFormatter)<CustomProperties>`
  color: ${props => props.disabledColor};
`;
export function Percent(props: PercentProps) {
  return (
    <StyledNumberFormatter
      {...props}
      incrementStep={props.incrementStep ?? defaultIncrementStep}
      precision={props.precision ?? 3}
      className={`${props.className} ${props.isCellInactive ? 'pe-none' : ''}`}
    />
  );
}
Percent.displayName = 'Percent';

export const PercentSkeleton: FC = () => {
  return (
    <div className="form-control">
      <Skeleton width="4em" />
    </div>
  );
};
Percent.displayName = 'Percent';
